import React, { useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import HelpCenterPopupComponent from "./HelpCenterPopupComponent";
import { gettingStartedData } from "../../Api/help-center-json-data/getting-started";
import HelpCenterTitleComponent from "./HelpCenterTitleComponent";

const GettingStartedTabComponent = () => {
  const styles = useStyles();
  const [activeTab, setActiveTab] = useState("players");

  const tabs = Object.keys(gettingStartedData.GettingStarted)
    .filter((key) => key === "Players" || key === "Audience")
    .map((key) => {
      return {
        key: key.toLowerCase(),
        title: key,
        steps: gettingStartedData.GettingStarted[key].Steps,
      };
    });
  const renderTabButton = (tab) => (
    <TouchableOpacity
      key={tab.key}
      onPress={() => setActiveTab((prev) => (prev === tab.key ? "" : tab.key))}
    >
      <View style={styles.tabButton}>
        <View style={styles.tabTitleContainer}>
          <Text style={[AppFontStyle.BOLD_ANYBODY_12]}>{tab.title}</Text>
        </View>
        <View>
          <Image
            source={
              activeTab === tab.key
                ? AppImages.icRoundDownArrow
                : AppImages.icRoundUpArrow
            }
            style={styles.arrowIcon}
          />
        </View>
      </View>
    </TouchableOpacity>
  );
  return (
    <>
      <HelpCenterTitleComponent
        title={gettingStartedData.GettingStarted.Title}
      />
      <View
        style={{
          backgroundColor: AppColors.appBlueColor_3A5175,
          borderRadius: 10,
          padding: 20,
        }}
      >
        <View style={{ gap: 20 }}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 5 }]}>
            Getting started
          </Text>

          <View style={styles.tabContainer}>
            {tabs.map((tab) => renderTabButton(tab))}
          </View>

          {activeTab && (
            <View style={styles.contentContainer}>
              <HelpCenterPopupComponent
                steps={tabs.find((tab) => tab.key === activeTab).steps}
                topData={gettingStartedData.GettingStarted.GeneralTopData}
                bottomData={gettingStartedData.GettingStarted.GeneralBottomData}
              />
            </View>
          )}
        </View>
      </View>
    </>
  );
};

export default GettingStartedTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    tabContainer: {
      flexDirection: "row",
      gap: 20,
    },
    tabTitleContainer: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    tabButton: {
      flex: 1,
      paddingVertical: 8,
      flexDirection: "row",
      backgroundColor: AppColors.gray_6E90B4,
      paddingHorizontal: 10,
      borderRadius: 10,
      width: 154,
      height: 45,
    },

    contentContainer: {
      marginTop: 10,
      paddingHorizontal: 10,
    },
    arrowIcon: {
      width: 19,
      height: 19,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: { tabButton: { height: 29, width: 140 } },
    [DEVICE_SIZES.XS]: { tabButton: { height: 29, width: 140 } },
  }
);
